module.exports = __webpack_public_path__ + "img/base-mapmatch-5e30c087.png";